var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"toTxc","type":"button","value":"新窗口打开","onclick":"window.open('https://support.qq.com/products/135447?')"}})])}
var staticRenderFns = []

export { render, staticRenderFns }